import { Log } from "@fanfanlo";
import { roomData } from "../room/data";
import { IMatrixMessage } from "./types";

const fileLogger = new Log(false, 'im.client.room.messageUtils');
// fileLogger.childrenPaused = true;
// fileLogger.pause = true;
// 消息相关工具函数
export const messageUtils = {
  addMessage(roomId: string, message: IMatrixMessage) {
    const logger = fileLogger.sub(false, 'addMessage_fn');
    logger.pause = true;
    logger.log('addMessage', 'roomId=', roomId, 'message=', message);
    
    if (!message.event_id) {
      logger.error('No event_id in message:', message);
      return;
    }
    
    const messageId = message.event_id;
    
    // 只存储我们需要的字段
    const simplifiedMessage = {
      event_id: message.event_id,
      sender: message.sender,
      content: message.content,
      origin_server_ts: message.origin_server_ts,
      type: message.type
    };
    
    // 存储消息到消息映射
    const newMessagesMap = { ...roomData.messagesMap };
    newMessagesMap[messageId] = simplifiedMessage;
    
    // 将消息 ID 添加到房间的消息列表中
    const currentMessages = roomData.messages[roomId] || [];
    const newMessages = [...currentMessages];
    if (!newMessages.includes(messageId)) {
        newMessages.push(messageId);
    }
    
    logger.log('Message added', 'roomId=', roomId, 'messageId=', messageId, 'message=', simplifiedMessage, 'newMessages=', newMessages);
    logger.log('newMessagesMap=', newMessagesMap);
    
    // 更新数据
    const currentMessagesData = roomData.messages;
    currentMessagesData[roomId] = newMessages;
    
    const currentMessagesMap = roomData.messagesMap;
    currentMessagesMap[messageId] = simplifiedMessage;
  },
  
  getMessages(roomId: string) {
    const logger = fileLogger.sub(false, 'getMessages_fn');
    logger.pause = true;
    logger.log('getMessages', 'roomId=', roomId);
    const messageIds = roomData.messages[roomId] || [];
    return messageIds.map(id => roomData.messagesMap[id]);
  },
  
  getMessage(messageId: string) {
    const logger = fileLogger.sub(false, 'getMessage_fn');
    logger.pause = true;
    logger.log('getMessage', 'messageId=', messageId);
    return roomData.messagesMap[messageId];
  },
  
  clearMessages(roomId: string) {
    const logger = fileLogger.sub(false, 'clearMessages_fn');
    logger.pause = true;
    logger.log('clearMessages', 'roomId=', roomId);
    if (roomData.messages[roomId]) {
      // 清除消息 ID 列表，但保留消息映射中的消息对象
      roomData.messages[roomId] = [];
    }
  },
  
  // 清除特定消息
  removeMessage(roomId: string, messageId: string) {
    const logger = fileLogger.sub(false, 'removeMessage_fn');
    logger.pause = true;
    logger.log('removeMessage', 'roomId=', roomId, 'messageId=', messageId);
    if (roomData.messages[roomId]) {
      const index = roomData.messages[roomId].indexOf(messageId);
      if (index !== -1) {
        roomData.messages[roomId].splice(index, 1);
      }
    }
    
    // 注意：这里不移除 messagesMap 中的消息，因为其他房间可能还在引用它
    // 如果需要完全移除消息，可以添加一个引用计数或定期清理未引用的消息
  }
};
